package com.essntl.uikit.components.dropdown

import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.width
import androidx.compose.runtime.Composable
import androidx.compose.runtime.key
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.ui.Modifier
import androidx.compose.ui.unit.dp
import com.essntl.uikit.components.button.outline.EsMediumOutlineButton
import com.essntl.uikit.components.icons.EsIcons
import com.essntl.uikit.components.utils.spacing

@Composable
fun<T> EsGenericFilterDropdown(
    filterTitle: String,
    filterOptions: List<T>,
    selectedOption: T?,
    onFilterOptionSelected: (T?) -> Unit,
    multiSelectEnabled: Boolean = false,
) {
    Box {
        val isFilterExpanded = remember { mutableStateOf(false) }

        EsMediumOutlineButton(
            text = selectedOption?.toString() ?: filterTitle,
            onClick = {
                isFilterExpanded.value = !isFilterExpanded.value
            },
            suffixIconRes = if (isFilterExpanded.value) EsIcons.ArrowUp else EsIcons.ArrowDown,
        )

        EsFilterDropDownMenu(
            expanded = isFilterExpanded.value,
            onDismissRequest = { isFilterExpanded.value = false },
            list = filterOptions,
            selectedItemIds = setOf(selectedOption),
            clearing = false,
            content = {
                filterOptions.forEach { option ->
                    val isSelected = remember(option, selectedOption) {
                        option == selectedOption
                    }
                    key(option) {
                        EsFilterDropDownItem(
                            onClick = {
                                onFilterOptionSelected(if (isSelected) null else option)
                                isFilterExpanded.value = false
                            },
                            title = option.toString(),
                            selected = isSelected,
                            modifier = Modifier
                                .padding(
                                    vertical = .5f.spacing,
                                    horizontal = 1.5f.spacing,
                                ),
                        )
                    }
                }
            },
            modifier = Modifier
                .width(308.dp),
        )
    }
}